export default {
  title: {
    id: 'asp_action_bar_declare_problem_damaged_package_upload_step_title',
    defaultMessage: 'Upload photos for the agent to review',
  },
  damagedPackage: {
    id: 'asp_action_bar_problem_declaration_message_step_subtitle_damaged_package',
    defaultMessage: 'Damaged package and item in transit',
  },
  intro: {
    id: 'asp_action_bar_declare_problem_damaged_package_upload_step_form_intro',
    defaultMessage:
      'Once verified, the agent will open an investigation of the shipping provider and offer the customer a replacement or refund.',
  },
  uploadFieldLabel: {
    id: 'asp_action_bar_declare_problem_damaged_package_upload_step_upload_field',
    defaultMessage: 'Upload photos',
  },
  hintTitle: {
    id: 'asp_action_bar_declare_problem_damaged_package_upload_step_hint_title',
    defaultMessage: 'Upload photos of the:',
  },
  hint1: {
    id: 'asp_action_bar_declare_problem_damaged_package_upload_step_hint_1',
    defaultMessage: 'Package’s exterior',
  },
  hint2: {
    id: 'asp_action_bar_declare_problem_damaged_package_upload_step_hint_2',
    defaultMessage: 'Package’s interior (optional)',
  },
  hint3: {
    id: 'asp_action_bar_declare_problem_damaged_package_upload_step_hint_3',
    defaultMessage: 'Materials used to wrap',
  },
  hint4: {
    id: 'asp_action_bar_declare_problem_damaged_package_upload_step_hint_4',
    defaultMessage: 'Damaged item',
  },
}
